module.exports = __webpack_public_path__ + "img/Butterfly_00090.cab48453.png";